import React from 'react';
import { Row, Col } from 'antd';
import { openLinkUrl } from '../../util/common';
import { WeaErrorPage, WeaTools,WeaLocaleProvider } from 'ecCom';
const getLabel = WeaLocaleProvider.getLabel;
//个人数据元素
class DataCenterCom extends React.Component {
    constructor(props){
        super(props);
        this.state = {
            list: props.data,
            eContentShowType: this.props.esetting.eContentShowType
        }
        this.callBack = this.callBack.bind(this);
    };
    componentDidMount() {
        this.callBack();
    }
    componentWillReceiveProps(nextProps){
        this.setState({list: nextProps.data}, ()=> {
            this.callBack()
        });
    }

    callBack(){
        const {eid} = this.props;
        const openlink = this.props.esetting.linkmode;
        const eContentShowType = this.props.esetting.eContentShowType;
        if(eContentShowType !='1') {
            $(`#content_view_id_${eid} .module`).hover(function(dom) {                
                $(this).css("background-image", "none");             
                if(this.clientHeight==240){
                    $(this).find(".mtitle").show().css("padding-top", "104px");
                }else{
                     $(this).find(".mtitle").show().css("padding-top", "52px");
                }               
                $(this).css("opacity", '0.8')
            }, function() {
                $(this).css("background-image", "url(/images/homepage/portalcenter/" + $(this).attr("data-type") + "_wev8.png)");
                $(this).find(".mtitle").hide();
                $(this).css("opacity", '1')
            })
        }else {
            $(`#content_view_id_${eid} .module`).hover(function(dom) {
                $(this).css("background-image", "none");           
                if(this.clientHeight==240){
                    $(this).find(".mtitle").show().css("padding-top", "104px");
                }else{
                     $(this).find(".mtitle").show().css("padding-top", "52px");
                }  
                $(this).css("opacity", '0.8')
            }, function() {
                $(this).css("background-image", "none");
                $(this).find(".mtitle").show();
                $(this).css("opacity", '1')
            })
        }
        //去除点击事件绑定
        $(`#content_view_id_${eid} .module`).unbind("click");

        // $(".module").attr("onclick","");
        //再绑定点击事件
        $(`#content_view_id_${eid} .module`).click(function() {
            const dataUrl = $(this).attr("data-url");
            openLinkUrl(dataUrl, openlink);
        })
    }
    render() {
        const { list } = this.state;
        const { esetting } = this.props;
        let html = null;
        switch (list.length) {
            case 1:
            case 2:
            case 3:
                html = list.map(item => <Col span={24/list.length}><Module esetting={esetting} item={item} height='240'/></Col>);
                break;
            case 4:
                html = list.map(item => <Col span={12}><Module esetting={esetting} item={item} height='120'/></Col>);
                break;
            case 5:
                html = list.map((item, i) => {
                    switch (i) {
                        case 0:
                            return <Col span={8}><Module esetting={esetting} item={item} height='120'/><Module esetting={esetting} item={list[i+3]} height='120'/></Col>
                        case 1:
                            return <Col span={8}><Module esetting={esetting} item={item} height='240'/></Col>
                        case 2:
                            return <Col span={8}><Module esetting={esetting} item={item} height='120'/><Module esetting={esetting} item={list[i+2]} height='120'/></Col>
                        default:
                            return <div></div>;
                    }
                });
                break;
            case 6:
                html = list.map((item, i) => <Col span={8}><Module esetting={esetting} item={item} height='120'/></Col>);
                break;
            case 7:
                html = list.map((item, i) => {
                    switch (i) {
                        case 1:
                            return <Col span={8}><Row><Col span={12}><Module esetting={esetting} item={item} height='120'/></Col><Col span={12}><Module esetting={esetting} item={list[i+1]} height='120'/></Col></Row></Col>
                        case 2:
                            return <div></div>;
                        default:
                            return <Col span={8}><Module esetting={esetting} item={item} height='120'/></Col>
                    }
                });
                break;
            case 8:
                html = list.map((item, i) => {
                    switch (i) {
                        case 1:
                        case 4:
                            return <Col span={8}><Row><Col span={12}><Module esetting={esetting} item={item} height='120'/></Col><Col span={12}><Module esetting={esetting} item={list[i+1]} height='120'/></Col></Row></Col>
                        case 2:
                        case 5:
                            return <div></div>;
                        default:
                            return <Col span={8}><Module esetting={esetting} item={item} height='120'/></Col>
                    }
                });
                break;
            case 9:
                html = list.map((item, i) => {
                    switch (i) {
                        case 1:
                        case 4:
                        case 7:
                            return <Col span={8}><Row><Col span={12}><Module esetting={esetting} item={item} height='120'/></Col><Col span={12}><Module esetting={esetting} item={list[i+1]} height='120'/></Col></Row></Col>
                        case 2:
                        case 5:
                        case 8:
                            return <div></div>;
                        default:
                            return <Col span={8}><Module esetting={esetting} item={item} height='120'/></Col>
                    }
                });
                break;
        }
        return <Row>{html}</Row>
    }
}



class MyErrorHandler extends React.Component {
    render() {
        const hasErrorMsg = this.props.error && this.props.error !== "";
        return (
            <WeaErrorPage msg={hasErrorMsg?this.props.error:getLabel(385218,"对不起，该页面异常，请联系管理员！")} />
        );
    }
}
DataCenterCom = WeaTools.tryCatch(React, MyErrorHandler, { error: "" })(DataCenterCom);

export default DataCenterCom;

const Module = ({ esetting={}, item, height }) => {
    let pTop='0px';
    if(height=='240'){
        pTop='104px';
    }else{
        pTop='52px';
    }
    if(esetting.eContentShowType == '1'){
        return <div className={`module ${item.model}`} data-type={item.model} data-url={item.url} style={{backgroundColor:item.color,height:height+'px', backgroundImage: 'none'}}>
            <div className="num">{item.value}</div>
            <div className="mtitle" style={{display: 'block', paddingTop: pTop}}>{item.label}</div>
        </div>
    }else {
        return <div className={`module ${item.model}`} data-type={item.model} data-url={item.url} style={{backgroundColor:item.color,height:height+'px'}}>
            <div className="num">{item.value}</div>
            <div className="mtitle">{item.label}</div>
        </div>
    }
}


// WEBPACK FOOTER //
// ../src4js/pc4mobx/portal/elements/components/datacenter/DataCenter.js